import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 25px 0 5px;
`
